import { computed, Directive, inject, input } from '@angular/core';
import { Pv2ImageShape, Pv2ImageSize } from '../../content';
import { PlayerMix, StationManagerService } from '@splixer/player';
import { ContentMenuItem } from '../../models';

/**
 * Generic content list management.  Can deal with both ContentMenuItems and PlayerMixes (should we add Hosts and Programs?).
 * Simply generates a 'contentMenuItems' array that contains all the items.
 */
@Directive()
export class V3ContentListController {
  public items = input.required<
    ContentMenuItem[] | PlayerMix[] | undefined
  >();
  public imageSize = input<Pv2ImageSize>('large');
  public imageShape = input<Pv2ImageShape>('square');

  /*
  public scrollOnAll = input(false, {transform: booleanAttribute});
  public scrollOnMobile = input(false, {transform: booleanAttribute});
  public largeOnMobile = input(false, {transform: booleanAttribute});
  public roundedImages = input(false, {transform: booleanAttribute});
  */

  protected station = inject(StationManagerService);

  protected wrapperKlasses = computed(() => {
    return this.buildWrapperKlasses();
  });

  protected contentMenuItems = computed<ContentMenuItem[]>(() => {
    const contentItems: ContentMenuItem[] = [];
    const items = this.items();
    if (items) {
      for (const item of items) {
        if (item instanceof PlayerMix) {
          const ci = this.fromPlayerMix(item);
          if (ci) {
            contentItems.push(ci);
          }
        } else {
          contentItems.push(item);
        }
      }
    }
    return contentItems;
  });

  protected fromPlayerMix(item: PlayerMix): ContentMenuItem | undefined {
    if (item.uid) {
      const mi: ContentMenuItem = {
        id: item.uid,
        contentId: item.uid,
        playable: true,
        name: item.name ?? 'No Name!',
        tagLine: item.tagLine,
        thirdLine: item.hostName,
        duration: item.duration,
      };
      const imageSize = this.imageSize();
      if (imageSize !== 'none') {
        mi.backgroundImage = this.station.getMixImageUrl(
          item,
          imageSize === 'small',
        );
      }
      return mi;
    }
    return undefined;
  }

  /**
   * Builds and sets any required wrapper classes.  Can we convert to a computed???
   */
  buildWrapperKlasses(): string[] {
    return [];
  }
}
